import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper-files" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableButton = _resolveComponent("TableButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "above-table" }, [
      _createElementVNode("p", null, "Archivos")
    ], -1)),
    _createElementVNode("table", null, [
      _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Tipo archivo"),
          _createElementVNode("th", null, "Seleccionar archivo"),
          _createElementVNode("th", null, "Nombre del archivo"),
          _createElementVNode("th", null, "Cargar archivo nuevo")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _cache[18] || (_cache[18] = _createElementVNode("td", null, "Muestrario", -1)),
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "file",
              ref: "inventoryInput",
              hidden: "",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInventoryFileSelected && _ctx.onInventoryFileSelected(...args))),
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($event.target.value = ''))
            }, null, 544),
            _createVNode(_component_TableButton, {
              type: "SelectFile",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.inventoryInput.click()))
            })
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.inventoryFileName || "No has seleccionado un archivo"), 1),
          _createElementVNode("td", null, [
            _createVNode(_component_TableButton, {
              type: "UploadFile",
              onClick: _ctx.inventoryFileTransaction
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[19] || (_cache[19] = _createElementVNode("td", null, "Seguimiento", -1)),
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "file",
              ref: "sampleInput",
              hidden: "",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSampleFileSelected && _ctx.onSampleFileSelected(...args))),
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($event.target.value = ''))
            }, null, 544),
            _createVNode(_component_TableButton, {
              type: "SelectFile",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.sampleInput.click()))
            })
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.sampleFileName || "No has seleccionado un archivo"), 1),
          _createElementVNode("td", null, [
            _createVNode(_component_TableButton, {
              type: "UploadFile",
              onClick: _ctx.sampleFileTransaction
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[20] || (_cache[20] = _createElementVNode("td", null, "Cartera", -1)),
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "file",
              ref: "invoiceInput",
              hidden: "",
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onInvoiceFileSelected && _ctx.onInvoiceFileSelected(...args))),
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($event.target.value = ''))
            }, null, 544),
            _createVNode(_component_TableButton, {
              type: "SelectFile",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$refs.invoiceInput.click()))
            })
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.invoiceFileName || "No has seleccionado un archivo"), 1),
          _createElementVNode("td", null, [
            _createVNode(_component_TableButton, {
              type: "UploadFile",
              onClick: _ctx.invoiceFileTransaction
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[21] || (_cache[21] = _createElementVNode("td", null, "Pedidos", -1)),
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "file",
              ref: "orderInput",
              hidden: "",
              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onOrderFileSelected && _ctx.onOrderFileSelected(...args))),
              onClick: _cache[10] || (_cache[10] = ($event: any) => ($event.target.value = ''))
            }, null, 544),
            _createVNode(_component_TableButton, {
              type: "SelectFile",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$refs.orderInput.click()))
            })
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.orderFileName || "No has seleccionado un archivo"), 1),
          _createElementVNode("td", null, [
            _createVNode(_component_TableButton, {
              type: "UploadFile",
              onClick: _ctx.orderFileTransaction
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[22] || (_cache[22] = _createElementVNode("td", null, "Directorio de clientes", -1)),
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "file",
              ref: "clientInput",
              hidden: "",
              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onClientFileSelected && _ctx.onClientFileSelected(...args))),
              onClick: _cache[13] || (_cache[13] = ($event: any) => ($event.target.value = ''))
            }, null, 544),
            _createVNode(_component_TableButton, {
              type: "SelectFile",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$refs.clientInput.click()))
            })
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.clientFileName || "No has seleccionado un archivo"), 1),
          _createElementVNode("td", null, [
            _createVNode(_component_TableButton, {
              type: "UploadFile",
              onClick: _ctx.clientFileTransaction
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[23] || (_cache[23] = _createElementVNode("td", null, "Reporte de ventas", -1)),
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "file",
              ref: "reportInput",
              hidden: "",
              onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onReportFileSelected && _ctx.onReportFileSelected(...args))),
              onClick: _cache[16] || (_cache[16] = ($event: any) => ($event.target.value = ''))
            }, null, 544),
            _createVNode(_component_TableButton, {
              type: "SelectFile",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$refs.reportInput.click()))
            })
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.reportFileName || "No has seleccionado un archivo"), 1),
          _createElementVNode("td", null, [
            _createVNode(_component_TableButton, {
              type: "UploadFile",
              onClick: _ctx.reportFileTransaction
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ]))
}